module.exports = __webpack_public_path__ + "img/66.24a1e18d.jpg";